import { NgTemplateOutlet } from '@angular/common';
import { Component, input, model } from '@angular/core';

import { StatTile } from '../../../models';

@Component({
  selector: 'app-stat-tiles',
  templateUrl: './stat-tiles.component.html',
  styleUrl: './stat-tiles.component.scss',
  imports: [NgTemplateOutlet],
})
// A strip of headline numbers above a planning screen - the few figures somebody wants before
// they read the detail. Production plan, 2026-10-26.
//
// `selectable` turns the tiles with a `key` into filters (production progress board,
// 2026-10-27): clicking one chooses it, clicking it again clears it, and `selected` is a two-way
// model of the chosen key.
export class StatTilesComponent {
  public readonly tiles = input<StatTile[]>([]);
  public readonly selectable = input(false);
  public readonly selected = model<string | null>(null);

  // A named colour (styles/_planning.scss, plan-colour-*) wins over a tone.
  protected toneClass(tile: StatTile): string {
    if (tile.colour) {
      return `plan-colour-${tile.colour.toLowerCase()}`;
    }
    return tile.tone ? `plan-tone-${tile.tone}` : '';
  }

  protected hasTone(tile: StatTile): boolean {
    return !!tile.tone || !!tile.colour;
  }

  protected isSelectable(tile: StatTile): boolean {
    return this.selectable() && !!tile.key;
  }

  protected choose(tile: StatTile) {
    if (this.isSelectable(tile)) {
      this.selected.set(this.selected() === tile.key ? null : (tile.key ?? null));
    }
  }
}
